import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as Constant from '../../constant';
import LocalizedString from '../../localization';
import * as Helper from '../../helper';
import * as Validation from '../../validation';
import { LoadingIndicator } from '../../component';

const styles = {
  buttonContainer: {
    marginTop: 12,
    display: 'flex',
    justifyContent: 'space-between',
  },
  btnPrimary: {
    ...Constant.DEFAULT_STYLES.WEB_USER.BUTTON_PRIMARY,
  },
};

const ChangePasswordPage = ({
  handleSubmit, updatingPassword, onUpdatePassword, onCancel,
}) => (
  <div>
    <form onSubmit={handleSubmit(onUpdatePassword)}>
      <Grid container spacing={12}>
        <Grid item xs={12} md={12}>
          <Field
            name={Constant.RXFIELD_OLD_PASSWORD}
            type="password"
            disabled={updatingPassword}
            component={Helper.renderReduxFormTextField}
            label={LocalizedString.profileScreen.labelOldPassword}
          />

          <Field
            name={Constant.RXFIELD_NEW_PASSWORD}
            type="password"
            disabled={updatingPassword}
            component={Helper.renderReduxFormTextField}
            label={LocalizedString.profileScreen.labelNewPassword}
          />

          <Field
            name={Constant.RXFIELD_RE_NEW_PASSWORD}
            type="password"
            disabled={updatingPassword}
            component={Helper.renderReduxFormTextField}
            label={LocalizedString.profileScreen.labelConfirmNewPassword}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <div style={styles.buttonContainer}>
            <Button disabled={updatingPassword} color="primary" onClick={onCancel}>
              {LocalizedString.common.buttonCaptionCancel}
            </Button>
            <Button variant="contained" color="primary" type="submit" disabled={updatingPassword} style={styles.btnPrimary}>
              {LocalizedString.common.buttonCaptionSave}
            </Button>
          </div>
        </Grid>
      </Grid>
    </form>
    {updatingPassword && <LoadingIndicator />}
  </div>
);

export default reduxForm({
  form: Constant.RXFORM_PROFILE_SCREEN_PASSWORD,
  validate: Validation.rxformValidateChangePassword,
})(ChangePasswordPage);

ChangePasswordPage.propTypes = {
  updatingPassword: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onUpdatePassword: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ChangePasswordPage.defaultProps = {
  updatingPassword: false,
};
